import { render, staticRenderFns } from "./list-customers.vue?vue&type=template&id=4c509ca2&"
import script from "./list-customers.js?vue&type=script&lang=js&"
export * from "./list-customers.js?vue&type=script&lang=js&"
import style0 from "./list-customers.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports